/* Canvas Mérida · Probador de cuadros personalizados (sections/cm-perso.liquid)
- El cliente elige su foto (se procesa en su navegador), el mueble (sofá, cama, comedor, escritorio,
mueble o pared libre) y su ancho real; dibujamos todo a escala (techo 2.60 m, persona de 1.70 m).
- Recomendamos la medida por proporción con el mueble (como la guía de medidas) y por resolución de la foto.
- Lleva al producto con la variante (medida + marco) elegida. */
(function () {
'use strict';
var root = document.querySelector('[data-cm-pz]');
var dataEl = document.querySelector('[data-pz-data]');
if (!root || !dataEl || root.dataset.ready) return;
root.dataset.ready = '1';
var DATA; try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
var $ = function (s) { return root.querySelector(s); };
var scene = $('[data-pz-scene]'), svg = $('[data-pz-svg]'), dim = $('[data-pz-dim]');
var fileIn = $('[data-pz-file]');
var fmtBox = $('[data-pz-fmts]'), sizeSel = $('[data-pz-size]'), frameRow = $('[data-pz-frame-row]'), frameBox = $('[data-pz-frames]');
var furnBox = $('[data-pz-furn]'), wIn = $('[data-pz-w]'), wOut = $('[data-pz-wv]'), wLbl = $('[data-pz-wl]'), wTip = $('[data-pz-tip]'), presets = $('[data-pz-presets]');
var qBox = $('[data-pz-q]'), qBar = $('[data-pz-q-bar]'), qTxt = $('[data-pz-q-t]');
var priceEl = $('[data-pz-price]'), cmpEl = $('[data-pz-cmp]'), offEl = $('[data-pz-off]'), goBtn = $('[data-pz-go]'), note = $('[data-pz-note]');
var NS = 'http://www.w3.org/2000/svg', CEIL = 260, uid = 0;
var FRAMES = ['Solo bastidor', 'Flotante negro', 'Flotante blanco', 'Flotante dorado', 'Flotante plata', 'Flotante natural', 'Flotante chocolate'];
var FRAME_FILL = { 'Flotante negro': ['#2b2b2b', '#0d0d0d'], 'Flotante blanco': ['#ffffff', '#e4e4df'], 'Flotante dorado': ['#f7dc8a', '#b8862a'], 'Flotante plata': ['#f2f3f5', '#9aa0a8'], 'Flotante natural': ['#dcb78c', '#b88a5c'], 'Flotante chocolate': ['#5a3725', '#2e1b11'] };
// mismos muebles y rangos que la guía de medidas (assets/cm-sz.js)
var FURN = {
sofa: { min: 120, max: 320, def: 220, top: 85, r: .7, lbl: 'Ancho', noun: 'Sofá', de: 'del sofá', tip: 'Mídelo de brazo a brazo. Un sofá de 3 plazas mide unos 220 cm; un love seat, unos 150 cm.' },
cama: { min: 90, max: 220, def: 160, top: 115, r: .7, lbl: 'Ancho', noun: 'Cama', de: 'de la cama', tip: 'Toma el ancho de la cabecera o del colchón.', presets: [['Individual', 100], ['Matrimonial', 140], ['Queen', 160], ['King', 200]] },
comedor: { min: 90, max: 300, def: 180, top: 76, r: .7, lbl: 'Largo', noun: 'Mesa', de: 'de la mesa', tip: 'Mide el lado de la mesa que queda junto a la pared.' },
escritorio: { min: 80, max: 200, def: 120, top: 76, r: .75, lbl: 'Ancho', noun: 'Escritorio', de: 'del escritorio', tip: 'Ideal para que se vea detrás de ti en videollamadas.' },
consola: { min: 80, max: 240, def: 160, top: 75, r: .75, lbl: 'Ancho', noun: 'Mueble', de: 'del mueble', tip: 'Mueble de TV, aparador, consola o recibidor.' },
pared: { min: 100, max: 500, def: 300, top: 0, r: .5, lbl: 'Pared', noun: 'Pared', de: 'de la pared', tip: 'Mide la pared de esquina a esquina o entre puerta y ventana.' }
};
var SAMPLE = scene.getAttribute('data-sample') || "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 300 200' preserveAspectRatio='xMidYMid slice'%3E%3Cdefs%3E%3ClinearGradient id='a' x1='0' y1='0' x2='0' y2='1'%3E%3Cstop offset='0' stop-color='%23ff9a62'/%3E%3Cstop offset='.55' stop-color='%23ffd29a'/%3E%3Cstop offset='1' stop-color='%23ffe9c7'/%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width='300' height='200' fill='url(%23a)'/%3E%3Ccircle cx='205' cy='92' r='28' fill='%23fff3d6'/%3E%3Cpath d='M0 130 Q60 95 120 122 T240 112 T300 118 V200 H0Z' fill='%23e38a5c'/%3E%3Cpath d='M0 150 Q80 125 160 148 T300 140 V200 H0Z' fill='%231a2c86'/%3E%3Cpath d='M0 172 Q90 158 180 172 T300 168 V200 H0Z' fill='%2307145b'/%3E%3C/svg%3E";
var SIZE_RE = /(\d+(?:[.,]\d+)?)\s*(?:cm)?\s*[x×]\s*(\d+(?:[.,]\d+)?)/i;
var state = { f: null, size: null, frame: 'Solo bastidor', img: null, furn: 'sofa', w: 220 };
/* ---------- formatos ---------- */
var formats = (DATA.formats || []).map(function (f) {
var si = -1, fi = -1;
f.options.forEach(function (name, i) { if (/marco/i.test(name)) fi = i; });
f.variants.some(function (v) { for (var i = 0; i < v.o.length; i++) { if (i !== fi && SIZE_RE.test(v.o[i])) { si = i; return true; } } return false; });
var sizes = [], seen = {};
f.variants.forEach(function (v) {
var lab = v.o[si]; if (!lab || seen[lab]) return; seen[lab] = 1;
var m = lab.match(SIZE_RE); if (!m) return;
sizes.push({ label: lab, w: parseFloat(m[1].replace(',', '.')), h: parseFloat(m[2].replace(',', '.')) });
});
sizes.sort(function (a, b) { return a.w * a.h - b.w * b.h; });
f.si = si; f.fi = fi; f.sizes = sizes;
f.ratio = sizes.length ? sizes[0].w / sizes[0].h : 1;
return f;
}).filter(function (f) { return f.si >= 0 && f.sizes.length; });
if (!formats.length) return;
/* ---------- utilidades ---------- */
function money(cents) {
var v = cents / 100, dec = cents % 100 !== 0;
return '$' + v.toLocaleString('es-MX', { minimumFractionDigits: dec ? 2 : 0, maximumFractionDigits: dec ? 2 : 0 });
}
function short(lab) { var m = lab.match(SIZE_RE); return m ? m[1] + ' × ' + m[2] + ' cm' : lab; }
function variantFor(f, size, frame) {
var best = null;
f.variants.forEach(function (v) {
if (v.o[f.si] !== size.label) return;
if (f.fi >= 0 && v.o[f.fi] !== frame) return;
if (!best || (v.a && !best.a)) best = v;
});
return best;
}
function dpi(size) {
if (!state.img) return null;
var rc = size.w / size.h, ri = state.img.w / state.img.h;
var usedW = ri > rc ? state.img.h * rc : state.img.w;
return usedW / (size.w / 2.54);
}
function level(d) {
if (d == null) return null;
if (d >= 100) return { k: 'ok', pct: 100, t: 'Calidad excelente para esta medida' };
if (d >= 70) return { k: 'ok', pct: 82, t: 'Muy buena calidad para esta medida' };
if (d >= 48) return { k: 'mid', pct: 60, t: 'Buena calidad: a distancia normal se verá muy bien' };
if (d >= 32) return { k: 'warn', pct: 38, t: 'Calidad justa: te recomendamos una medida más chica o la foto original' };
return { k: 'bad', pct: 18, t: 'Resolución baja para esta medida: elige una más chica o manda la foto original' };
}
// medida recomendada: la más cercana a la proporción ideal del mueble y, si hay foto, con buena calidad
// (misma lógica que la guía: solo medidas que caben entre el mueble y el techo; un vertical o cuadrado "llena" más que su ancho)
function recommended(f) {
var F = FURN[state.furn], ideal = state.w * F.r, best = 0, bd = 1e9, minB = F.top ? F.top + 10 : 20;
f.sizes.forEach(function (z, i) {
if (i > 0 && minB + z.h > CEIL - 8) return;
if (state.img && dpi(z) < 48 && i > 0) return;
var r = z.w / z.h, eff = z.w / (r < 0.9 ? 0.55 : r < 1.1 ? 0.75 : 1);
var d = Math.abs(eff - ideal); if (d < bd) { bd = d; best = i; }
});
return best;
}
/* ---------- dibujo a escala ---------- */
function el(n, a, p) { var e = document.createElementNS(NS, n); for (var k in a) e.setAttribute(k, a[k]); if (p) p.appendChild(e); return e; }
function txt(p, x, y, t, a) { var e = el('text', Object.assign({ x: x, y: y, 'text-anchor': 'middle', 'font-family': 'inherit' }, a || {}), p); e.textContent = t; return e; }
function draw() {
var f = state.f, z = state.size; if (!f || !z) return;
var F = FURN[state.furn], H = CEIL, wall = state.furn === 'pared', fw = wall ? 0 : state.w;
var framed = f.fi >= 0 && state.frame !== 'Solo bastidor', fr = framed ? 3.5 : 0;
var ow = z.w + 2 * fr, oh = z.h + 2 * fr;
var W = Math.max(420, (wall ? state.w : fw) + 220, ow + 170);
var VH = Math.max(H + 32, W / 1.44), y0 = H + 20 - VH;
svg.setAttribute('viewBox', '0 ' + y0 + ' ' + W + ' ' + VH);
svg.innerHTML = '';
var id = 'pz' + (++uid), defs = el('defs', {}, svg);
var sh = el('filter', { id: id + 's', x: '-10%', y: '-10%', width: '130%', height: '140%' }, defs);
el('feDropShadow', { dx: '1.5', dy: '3', stdDeviation: '2.5', 'flood-color': '#000', 'flood-opacity': '.3' }, sh);
var cx = W / 2;
el('rect', { x: 0, y: y0, width: W, height: H - y0, fill: '#efe9df' }, svg);
if (wall) { var x0 = cx - state.w / 2; el('rect', { x: 0, y: y0, width: Math.max(0, x0), height: H - y0, fill: '#e2dacd' }, svg); el('rect', { x: x0 + state.w, y: y0, width: Math.max(0, W - x0 - state.w), height: H - y0, fill: '#e2dacd' }, svg); }
el('rect', { x: 0, y: H, width: W, height: 20, fill: '#c9b194' }, svg); el('rect', { x: 0, y: H, width: W, height: 2, fill: '#ae9575' }, svg);
// mueble
var g = el('g', { fill: '#1d2a6b' }, svg), x = cx - fw / 2;
if (state.furn === 'sofa') {
el('rect', { x: x + 8, y: H - 85, width: fw - 16, height: 48, rx: 10 }, g); el('rect', { x: x, y: H - 48, width: fw, height: 34, rx: 8, fill: '#24357f' }, g);
el('rect', { x: x, y: H - 62, width: 20, height: 50, rx: 8 }, g); el('rect', { x: x + fw - 20, y: H - 62, width: 20, height: 50, rx: 8 }, g);
el('rect', { x: x + 10, y: H - 14, width: 5, height: 14, fill: '#5a4632' }, g); el('rect', { x: x + fw - 15, y: H - 14, width: 5, height: 14, fill: '#5a4632' }, g);
var cn = Math.max(2, Math.round(fw / 75)); for (var i = 0; i < cn; i++) el('rect', { x: x + 24 + i * ((fw - 48) / cn) + 4, y: H - 80, width: (fw - 48) / cn - 8, height: 30, rx: 8, fill: i === 0 ? '#f5b301' : '#33479a' }, g);
} else if (state.furn === 'cama') {
el('rect', { x: x - 6, y: H - F.top, width: fw + 12, height: F.top - 30, rx: 8 }, g); el('rect', { x: x, y: H - 55, width: fw, height: 28, rx: 6, fill: '#e9e6f2' }, g);
el('rect', { x: x, y: H - 30, width: fw, height: 22, rx: 4, fill: '#24357f' }, g); el('rect', { x: x + 10, y: H - 72, width: fw / 2 - 16, height: 20, rx: 8, fill: '#fff' }, g); el('rect', { x: cx + 6, y: H - 72, width: fw / 2 - 16, height: 20, rx: 8, fill: '#fff' }, g);
} else if (state.furn === 'comedor') {
el('rect', { x: x, y: H - F.top, width: fw, height: 5, rx: 2, fill: '#6b4f36' }, g); el('rect', { x: x + 12, y: H - F.top, width: 5, height: F.top, fill: '#6b4f36' }, g); el('rect', { x: x + fw - 17, y: H - F.top, width: 5, height: F.top, fill: '#6b4f36' }, g);
[x + fw * 0.22, x + fw * 0.5, x + fw * 0.78].forEach(function (c) { el('rect', { x: c - 20, y: H - 95, width: 40, height: 48, rx: 6 }, g); el('rect', { x: c - 20, y: H - 47, width: 4, height: 47 }, g); el('rect', { x: c + 16, y: H - 47, width: 4, height: 47 }, g); });
} else if (state.furn === 'escritorio') {
el('rect', { x: x, y: H - F.top, width: fw, height: 5, rx: 2, fill: '#6b4f36' }, g); el('rect', { x: x + 6, y: H - F.top, width: 5, height: F.top, fill: '#6b4f36' }, g); el('rect', { x: x + fw - 11, y: H - F.top, width: 5, height: F.top, fill: '#6b4f36' }, g);
el('rect', { x: cx - 26, y: H - F.top - 34, width: 52, height: 32, rx: 3, fill: '#2b2b2b' }, g); el('rect', { x: cx - 3, y: H - F.top - 3, width: 6, height: 3, fill: '#2b2b2b' }, g);
el('rect', { x: cx - 24, y: H - 110, width: 48, height: 52, rx: 10 }, g); el('rect', { x: cx - 3, y: H - 58, width: 6, height: 50 }, g); el('rect', { x: cx - 22, y: H - 8, width: 44, height: 5, rx: 2 }, g);
} else if (state.furn === 'consola') {
el('rect', { x: x, y: H - F.top, width: fw, height: F.top - 12, rx: 4, fill: '#7a5b3e' }, g); el('rect', { x: x + 6, y: H - 12, width: 5, height: 12, fill: '#4d3824' }, g); el('rect', { x: x + fw - 11, y: H - 12, width: 5, height: 12, fill: '#4d3824' }, g);
el('path', { d: 'M' + cx + ' ' + (H - F.top + 6) + 'V' + (H - 18), stroke: '#5d4430', 'stroke-width': 1.5 }, g); el('rect', { x: x + fw * 0.12, y: H - F.top - 34, width: 14, height: 34, rx: 6, fill: '#c9a36a' }, g);
}
// persona de 1.70 m como referencia
var px = wall ? Math.max(28, cx - state.w / 2 + 30) : cx - fw / 2 - 48; if (px < 28) px = cx + fw / 2 + 48;
if (px < W - 20) {
var pg = el('g', { fill: '#b7bdd3' }, svg); el('circle', { cx: px, cy: H - 158, r: 11 }, pg); el('rect', { x: px - 17, y: H - 145, width: 34, height: 62, rx: 12 }, pg);
el('rect', { x: px - 15, y: H - 88, width: 13, height: 88, rx: 6 }, pg); el('rect', { x: px + 2, y: H - 88, width: 13, height: 88, rx: 6 }, pg);
txt(svg, px, H - 174, '1.70 m', { 'font-size': 9, fill: '#7c839f', 'font-weight': 700 });
}
// altura de colgado: borde inferior 15-25 cm sobre el mueble; en pared libre, centro a 1.50 m
var b = F.top ? Math.max(F.top + 20, 150 - oh / 2) : 150 - oh / 2;
if (b + oh > H - 8) b = Math.max(F.top ? F.top + 8 : 12, H - 8 - oh);
b = Math.max(b, 6);
var oy = H - b - oh, ox = cx - ow / 2, ax = ox + fr, ay = oy + fr;
var art = el('g', { filter: 'url(#' + id + 's)' }, svg);
if (framed) {
var c = FRAME_FILL[state.frame] || ['#333', '#111'], lg = el('linearGradient', { id: id + 'f', x1: '0', y1: '0', x2: '1', y2: '1' }, defs);
el('stop', { offset: '0', 'stop-color': c[0] }, lg); el('stop', { offset: '1', 'stop-color': c[1] }, lg);
el('rect', { x: ox, y: oy, width: ow, height: oh, fill: 'url(#' + id + 'f)' }, art);
el('rect', { x: ax - 1, y: ay - 1, width: z.w + 2, height: z.h + 2, fill: '#141414', opacity: '.75' }, art);
} else {
el('rect', { x: ax, y: ay, width: z.w, height: z.h, fill: '#d9dbe6' }, art);
}
var clip = el('clipPath', { id: id + 'c' }, defs); el('rect', { x: ax, y: ay, width: z.w, height: z.h }, clip);
var im = el('image', { x: ax, y: ay, width: z.w, height: z.h, preserveAspectRatio: 'xMidYMid slice', 'clip-path': 'url(#' + id + 'c)' }, svg);
var src = state.img ? state.img.url : SAMPLE; im.setAttribute('href', src); im.setAttributeNS('http://www.w3.org/1999/xlink', 'href', src);
el('rect', { x: ax, y: ay, width: z.w, height: z.h, fill: 'none', stroke: 'rgba(0,0,0,.18)', 'stroke-width': .8 }, svg);
// cotas
var red = '#e3262f';
el('path', { d: 'M' + ox + ' ' + (oy - 8) + 'H' + (ox + ow) + 'M' + ox + ' ' + (oy - 12) + 'v8M' + (ox + ow) + ' ' + (oy - 12) + 'v8', stroke: red, 'stroke-width': 1.2, fill: 'none' }, svg);
var lab = el('g', {}, svg); el('rect', { x: cx - 30, y: oy - 21, width: 60, height: 14, rx: 7, fill: red }, lab); txt(lab, cx, oy - 11, Math.round(ow) + ' cm', { 'font-size': 9, fill: '#fff', 'font-weight': 800 });
var rx2 = ox + ow + 8; el('path', { d: 'M' + rx2 + ' ' + oy + 'V' + (oy + oh) + 'M' + (rx2 - 4) + ' ' + oy + 'h8M' + (rx2 - 4) + ' ' + (oy + oh) + 'h8', stroke: red, 'stroke-width': 1.2, fill: 'none' }, svg);
var hl = el('text', { x: rx2 + 6, y: oy + oh / 2 + 3, 'font-size': 9, fill: red, 'font-weight': 800 }, svg); hl.textContent = Math.round(oh) + ' cm';
txt(svg, cx, H + 13, wall ? 'Pared de ' + state.w + ' cm' : F.noun + ' de ' + state.w + ' cm', { 'font-size': 9, fill: '#5d4a35', 'font-weight': 700 });
dim.textContent = short(z.label) + (framed ? ' + marco' : '');
}
/* ---------- controles ---------- */
function renderFormats() {
fmtBox.innerHTML = formats.map(function (f) {
var on = f === state.f;
return '<button type="button" class="cm-pz__fbtn' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + on + '" data-key="' + f.key + '">' +
'<span class="cm-pz__fico cm-pz__fshape--' + f.key + '" aria-hidden="true"><span></span></span>' + f.name + (f.rec ? '<em>Ideal para tu foto</em>' : '') + '</button>';
}).join('');
}
function renderSizes() {
var f = state.f, rec = recommended(f);
sizeSel.innerHTML = f.sizes.map(function (z, i) {
var v = variantFor(f, z, state.frame) || variantFor(f, z, 'Solo bastidor');
var lv = level(dpi(z));
var mark = lv ? (lv.k === 'ok' || lv.k === 'mid' ? '  ✓' : '  ⚠') : '';
return '<option value="' + i + '"' + (z === state.size ? ' selected' : '') + '>' + short(z.label) + (v ? ' — ' + money(v.p) : '') + mark + (i === rec ? '  ★ ideal' : '') + '</option>';
}).join('');
}
function renderFrames() {
var f = state.f;
if (f.fi < 0) {
var withFrame = formats.filter(function (x) { return x.fi >= 0; }).map(function (x) { return x.name; });
frameBox.innerHTML = withFrame.length ? '<span class="cm-pz__frm-name cm-pz__frm-name--na">Marco flotante disponible en formato ' + withFrame.join(' y ') + '</span>' : '';
frameRow.hidden = !withFrame.length;
return;
}
frameRow.hidden = false;
var avail = {};
f.variants.forEach(function (v) { avail[v.o[f.fi]] = 1; });
frameBox.innerHTML = FRAMES.filter(function (n) { return avail[n]; }).map(function (n) {
var on = n === state.frame;
return '<button type="button" class="cm-pz__frm' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + on + '" data-frame="' + n + '" title="' + n + '" aria-label="' + n + '"><span class="cm-pz__sw" data-c="' + n + '"></span></button>';
}).join('') + '<span class="cm-pz__frm-name">' + state.frame.replace('Flotante ', 'Marco flotante ') + '</span>';
}
function renderBuy() {
var f = state.f, z = state.size;
var v = variantFor(f, z, state.frame) || variantFor(f, z, 'Solo bastidor');
if (!v) { priceEl.textContent = '—'; goBtn.removeAttribute('href'); return; }
priceEl.textContent = money(v.p);
if (v.c > v.p) { cmpEl.textContent = money(v.c); offEl.textContent = '-' + Math.round((v.c - v.p) / v.c * 100) + '%'; }
else { cmpEl.textContent = ''; offEl.textContent = ''; }
goBtn.href = f.url + '?variant=' + v.id;
var lv = level(dpi(z));
qBox.hidden = !lv;
if (lv) { qBox.setAttribute('data-k', lv.k); qBar.style.width = lv.pct + '%'; qTxt.textContent = lv.t; }
var pct = Math.round(z.w / state.w * 100), F = FURN[state.furn];
note.textContent = 'Tu cuadro ocupa el ' + pct + '% del ancho ' + F.de + '. ' +
(state.img ? 'En la página del producto subes esta misma foto y terminas tu pedido.' : 'Elige tu foto para ver qué tan nítida quedará.');
}
function renderFurn() {
var F = FURN[state.furn];
[].forEach.call(furnBox.querySelectorAll('[data-furn]'), function (b) { var on = b.getAttribute('data-furn') === state.furn; b.setAttribute('aria-checked', on); b.classList.toggle('is-on', on); });
wIn.min = F.min; wIn.max = F.max; wIn.value = state.w; wOut.textContent = state.w;
wLbl.textContent = F.lbl; wTip.textContent = F.tip;
if (F.presets) {
presets.hidden = false;
presets.innerHTML = F.presets.map(function (p) { return '<button type="button" class="cm-pz__pre' + (p[1] === state.w ? ' is-on' : '') + '" data-w="' + p[1] + '">' + p[0] + ' <small>' + p[1] + '</small></button>'; }).join('');
} else { presets.hidden = true; presets.innerHTML = ''; }
}
function renderAll() { renderFormats(); renderFurn(); renderSizes(); renderFrames(); renderBuy(); draw(); }
function pick() { state.size = state.f.sizes[recommended(state.f)]; }
function setFormat(f) { state.f = f; if (f.fi < 0) state.frame = 'Solo bastidor'; pick(); renderAll(); }
function setFurn(k) { state.furn = k; state.w = FURN[k].def; pick(); renderAll(); }
function setWidth(w) { state.w = w; pick(); wOut.textContent = w; renderSizes(); renderBuy(); draw(); if (FURN[state.furn].presets) renderFurn(); }
fmtBox.addEventListener('click', function (e) {
var b = e.target.closest('[data-key]'); if (!b) return;
var f = formats.filter(function (x) { return x.key === b.getAttribute('data-key'); })[0];
if (f) setFormat(f);
});
furnBox.addEventListener('click', function (e) { var b = e.target.closest('[data-furn]'); if (b) setFurn(b.getAttribute('data-furn')); });
furnBox.addEventListener('keydown', function (e) {
if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) < 0) return;
e.preventDefault();
var ks = Object.keys(FURN), i = ks.indexOf(state.furn), n = ks[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : ks.length - 1)) % ks.length];
setFurn(n); var nb = furnBox.querySelector('[data-furn="' + n + '"]'); if (nb) nb.focus();
});
wIn.addEventListener('input', function () { setWidth(parseInt(wIn.value, 10)); });
presets.addEventListener('click', function (e) { var b = e.target.closest('[data-w]'); if (!b) return; var w = parseInt(b.getAttribute('data-w'), 10); wIn.value = w; setWidth(w); });
sizeSel.addEventListener('change', function () { state.size = state.f.sizes[+sizeSel.value]; renderFrames(); renderBuy(); draw(); });
frameBox.addEventListener('click', function (e) {
var b = e.target.closest('[data-frame]'); if (!b) return;
state.frame = b.getAttribute('data-frame'); renderSizes(); renderFrames(); renderBuy(); draw();
});
goBtn.addEventListener('click', function () {
try { if (window.gtag) gtag('event', 'personalizado_probador', { formato: state.f.name, medida: state.size.label, marco: state.frame, mueble: state.furn, ancho_mueble: state.w, con_foto: !!state.img }); } catch (e) {}
try { sessionStorage.setItem('cmPzChoice', JSON.stringify({ f: state.f.key, s: state.size.label, m: state.frame, mueble: state.furn, w: state.w })); } catch (e) {}
});
/* ---------- foto del cliente ---------- */
function useFile(file) {
if (!file || !/^image\//.test(file.type)) return;
var url = URL.createObjectURL(file), im = new Image();
im.onload = function () {
state.img = { w: im.naturalWidth, h: im.naturalHeight, url: url };
scene.classList.add('has-photo');
var r = im.naturalWidth / im.naturalHeight, best = formats[0], bd = 1e9;
formats.forEach(function (f) { f.rec = false; var d = Math.abs(Math.log(r) - Math.log(f.ratio)); if (d < bd) { bd = d; best = f; } });
best.rec = true;
setFormat(best);
try { if (window.gtag) gtag('event', 'personalizado_foto', { formato: best.name }); } catch (e) {}
};
im.onerror = function () { note.textContent = 'No pudimos leer esa imagen. Prueba con una foto JPG o PNG.'; };
im.src = url;
}
fileIn.addEventListener('change', function () { useFile(fileIn.files && fileIn.files[0]); });
['dragenter', 'dragover'].forEach(function (t) { scene.addEventListener(t, function (e) { e.preventDefault(); scene.classList.add('is-drag'); }); });
['dragleave', 'drop'].forEach(function (t) { scene.addEventListener(t, function (e) { e.preventDefault(); scene.classList.remove('is-drag'); }); });
scene.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; useFile(f); });
root.addEventListener('click', function (e) {
var b = e.target.closest('[data-pz-pick]'); if (!b) return;
e.preventDefault();
var t = document.getElementById('cm-pz-try');
if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
fileIn.click();
});
/* ---------- inicio ---------- */
var q = new URLSearchParams(location.search).get('mueble');
if (q && FURN[q]) { state.furn = q; state.w = FURN[q].def; }
setFormat(formats[0]);
})();